import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Autoplay, Pagination } from "swiper/modules";

function DitapBuilder({ getData }) {
  useEffect(() => {
    getData(
      "DiTAP Builder",
      "웹 기반 3차원 지도 상의 원활한 GIS 데이터",
      "가시화를 위한 파일 변환 시스템"
    );
  }, [getData]);

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  //스와이프
  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return (
        '<div class="ditap-slider-control-btn ' +
        className +
        '"><p>0' +
        (index + 1) +
        "</p><p class='ditap-slider-bar'></p></div>"
      );
    },
  };

  const [swiper, setSwiper] = useState(null);
  // swiper instance
  const [play, setPlay] = useState(true); // auto play 기준

  useEffect(() => {
    const swiperInstance = document.querySelector(".auto-swiper").swiper;

    setSwiper(swiperInstance);
  }, []);

  useEffect(() => {
    if (typeof swiper === "object") {
      if (play) {
        swiper?.autoplay.start();
      } else {
        swiper?.autoplay.stop();
      }
    }
  }, [swiper, play]);

  const onClickAutoPlayBtn = () => {
    setPlay(!play);
  };

  return (
    <>
      {pc ? (
        <>
          <div className="inner">
            <div>
              <div className="basic-title-desc">
                <div>
                  <h2 className="basic-title">DiTAP Builder</h2>
                  <div className="basic-subtitle">
                    <p>
                      3D Tiles, 3D Model, Point Cloud, 정사 영상, DEM 타입의
                      변환을 지원하고
                    </p>
                    <p>
                      변환 이력 관리, 데이터 시각화 및 다운로드가 가능합니다.
                    </p>
                  </div>
                </div>
                <p className="mark"></p>
              </div>

              <p className="basic-banner ditap-unity-banner"></p>
              <div>
                <ul className="ditap-info-list">
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapbuilder-info1"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">3D Tiles 변환</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          ifc, obj, dae, abc, ply, stl, fbx, glb, gltf, skp, 3ds
                          파일 지원
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapbuilder-info2"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">3D Model 변환</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          ifc, obj, dae, abc, ply, stl, fbx, glb, gltf, skp, 3ds
                          파일 지원
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapbuilder-info3"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">Point Cloud 변환</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>las 파일 변환</p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapbuilder-info4"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">변환 이력 조회 및</span>
                        <span className="basic-block">시각화</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>변환 진행 및 완료된 파일을 이력 조회, 시각화 가능</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ditap-banner">
              <div className="basic-title">
                <p className="txt">웹 기반 3차원 지도 상의 원활한</p>
                <p className="txt">GIS 데이터 가시화를 위한 파일 변환 시스템</p>
              </div>
              <p className="basic-banner ditap-builder-banner2"></p>
            </div>
            <div className="ditap-introduce">
              <div className="basic-title">
                <p className="txt">DiTAP Builder 주요 기능</p>
              </div>
              <div className="ditap-introduce-item">
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box builder-introduce-img1"></div>
                  <div>
                    <h3 className="ditap-introduce-subtitle">3D Tiles</h3>
                    <div className="ditap-introduce-cont">
                      <p>
                        하나 이상의 모델 파일을 3D 지도에 가시화가 가능한
                        포맷으로 세분화하여 가공합니다.
                      </p>
                      <p>
                        또한 ifc, obj, dae, abc, ply, stl, fbx, glb, gltf, 3ds,
                        zip 파일을 지원합니다.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="ditap-introduce-list">
                  <div>
                    <div>
                      <h3 className="ditap-introduce-subtitle">3D Model</h3>
                      <div className="ditap-introduce-cont">
                        <p>
                          하나의 모델 파일을 3D 지도에 가시화가 가능한 포맷으로
                          가공합니다. 또한 ifc, obj, dae, abc, ply, stl, fbx,
                          glb, gltf, 3ds, zip 파일을 지원합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="ditap-introduce-img-box builder-introduce-img2"></div>
                </div>
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box builder-introduce-img3"></div>
                  <div>
                    <div>
                      <h3 className="ditap-introduce-subtitle">Point Cloud</h3>
                      <div className="ditap-introduce-cont">
                        <p>
                          Point Cloud 파일을 3D 지도에 가시화가 가능한 포맷으로
                          세분화하여 가공합니다.
                        </p>
                        <p>또한 las 파일을 지원합니다.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="ditap-used-wrap">
                <button
                  onClick={onClickAutoPlayBtn}
                  className="ditap-slider-control-btn swiper-stop-control"
                ></button>
                <div className="ditap-used-item">
                  <Swiper
                    autoplay={{
                      delay: 5000,
                      disableOnInteraction: false,
                    }}
                    pagination={pagination}
                    modules={[Autoplay, Pagination]}
                    className="auto-swiper"
                  >
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">
                              디지털 트윈 국토 플랫폼 데이터 구축
                            </span>
                            <span className="basic-block">
                              메타버스 기반 가상부동산 플랫폼 데이터 구축
                            </span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              연도별 GIS 데이터 구축 및 속성정보 연계와 도시
                              건물 편집 및 일조, 인공 광원 배치 시뮬레이션
                              기능에 활용할 수 있습니다.
                            </p>
                            <p>
                              메타버스 기반 가상부동산 플랫폼 데이터에서는
                              사용자 선택 영역별 GIS 데이터 구축 및 속성정보
                              연계와 메타버스 체험 및 매장 체험 기능, 홍보 효과
                              확대에 활용했습니다.
                            </p>
                          </div>
                        </div>
                        <p className="ditap-used-img builder-used1"></p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">웹 기반 GIS</span>
                            <span className="basic-block">
                              데이터 변환 및 시각화
                            </span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              대용량의 GIS 데이터를 웹 기반의 3차원 지도에
                              시각화하기 위한 변환 기능을 제공하고 이력으로
                              관리하는 기능을 제공하는 시스템으로서, 계정 별로
                              변환된 데이터를 확인 및 삭제가 가능하여 데이터의
                              검증 및 관리가 용이한 '웹 기반 3차원 GIS 데이터
                              관리 시스템'입니다.
                            </p>
                          </div>
                        </div>
                        <p className="ditap-used-img builder-used2"></p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">변환 데이터</span>
                            <span className="basic-block">
                              다운로드 및 활용
                            </span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              변환된 GIS 데이터는 자체적인 웹 페이지에서
                              시각화할 수 있을 뿐만 아니라 리소스의 주소 정보
                              또는 변환 파일 다운로드 기능을 통해 외부 시스템과
                              손쉽게 연동이 가능하여 활용도가 높은 시스템입니다.
                            </p>
                          </div>
                        </div>
                        <p className="ditap-used-img builder-used3"></p>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="inner">
            <div>
              <div className="basic-title-desc">
                <h2 className="basic-title">DiTAP Builder</h2>
                <p className="mark"></p>
              </div>
              <div className="basic-subtitle">
                <p>
                  3D Tiles, 3D Model, Point Cloud, 정사 영상, DEM 타입의 변환을
                  지원하고
                </p>
                <p>변환 이력 관리, 데이터 시각화 및 다운로드가 가능합니다.</p>
              </div>
              <p className="basic-banner ditap-unity-banner"></p>
              <div>
                <ul className="ditap-info-list">
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapbuilder-info1"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">3D Tiles 변환</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          ifc, obj, dae, abc, ply, stl, fbx, glb, gltf, skp, 3ds
                          파일 지원
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapbuilder-info2"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">3D Model 변환</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          ifc, obj, dae, abc, ply, stl, fbx, glb, gltf, skp, 3ds
                          파일 지원
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapbuilder-info3"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">Point Cloud 변환</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>las 파일 변환</p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapbuilder-info4"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">변환 이력 조회 및</span>
                        <span className="basic-block">시각화</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>변환 진행 및 완료된 파일을 이력 조회, 시각화 가능</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ditap-banner">
              <div className="basic-title">
                <p className="txt">웹 기반 3차원 지도 상의 원활한</p>
                <p className="txt">GIS 데이터 가시화를 위한 파일 변환 시스템</p>
              </div>
              <p className="basic-banner ditap-builder-banner2"></p>
            </div>
            <div className="ditap-introduce">
              <div className="basic-title">
                <p className="txt">DiTAP Builder</p>
                <p className="txt">주요 기능</p>
              </div>
              <div className="ditap-introduce-item">
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box builder-introduce-img1"></div>
                  <div>
                    <h3 className="ditap-introduce-subtitle">3D Tiles</h3>
                    <div className="ditap-introduce-cont">
                      <p>
                        하나 이상의 모델 파일을 3D 지도에 가시화가 가능한
                        포맷으로 세분화하여 가공합니다.
                      </p>
                      <p>
                        또한 ifc, obj, dae, abc, ply, stl, fbx, glb, gltf, 3ds,
                        zip 파일을 지원합니다.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box builder-introduce-img2"></div>
                  <div>
                    <div>
                      <h3 className="ditap-introduce-subtitle">3D Model</h3>
                      <div className="ditap-introduce-cont">
                        <p>
                          하나의 모델 파일을 3D 지도에 가시화가 가능한 포맷으로
                          가공합니다. 또한 ifc, obj, dae, abc, ply, stl, fbx,
                          glb, gltf, 3ds, zip 파일을 지원합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box builder-introduce-img3"></div>
                  <div>
                    <div>
                      <h3 className="ditap-introduce-subtitle">Point Cloud</h3>
                      <div className="ditap-introduce-cont">
                        <p>
                          Point Cloud 파일을 3D 지도에 가시화가 가능한 포맷으로
                          세분화하여 가공합니다.
                        </p>
                        <p>또한 las 파일을 지원합니다.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="ditap-used-wrap">
                <div className="ditap-used-item">
                  <button
                    onClick={onClickAutoPlayBtn}
                    className="ditap-slider-control-btn swiper-stop-control"
                  ></button>
                  <Swiper
                    autoplay={{
                      delay: 5000,
                      disableOnInteraction: false,
                    }}
                    pagination={pagination}
                    modules={[Autoplay, Pagination]}
                    className="auto-swiper"
                  >
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">
                              디지털 트윈 국토 플랫폼 데이터 구축
                            </span>
                            <span className="basic-block">
                              메타버스 기반 가상부동산 플랫폼
                            </span>
                            <span className="basic-block">데이터 구축</span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              연도별 GIS 데이터 구축 및 속성정보 연계와 도시
                              건물 편집 및 일조, 인공 광원 배치시뮬레이션 기능에
                              활용할 수 있습니다. 메타버스 기반 가상부동산
                              플랫폼 데이터에서는 사용자 선택 영역별 GIS 데이터
                              구축 및 속성정보 연계와 메타버스 체험 및 매장 체험
                              기능, 홍보 효과 확대에 활용했습니다.
                            </p>
                          </div>
                        </div>
                        <p className="ditap-used-img builder-used1"></p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">웹 기반 GIS</span>
                            <span className="basic-block">
                              데이터 변환 및 시각화
                            </span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              대용량의 GIS 데이터를 웹 기반의 3차원 지도에
                              시각화하기 위한 변환 기능을 제공하고 이력으로
                              관리하는 기능을 제공하는 시스템으로서, 계정 별로
                              변환된 데이터를 확인 및 삭제가 가능하여 데이터의
                              검증 및 관리가 용이한 '웹 기반 3차원 GIS 데이터
                              관리 시스템'입니다.
                            </p>
                          </div>
                        </div>
                        <p className="ditap-used-img builder-used2"></p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">변환 데이터</span>
                            <span className="basic-block">
                              다운로드 및 활용
                            </span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              변환된 GIS 데이터는 자체적인 웹 페이지에서
                              시각화할 수 있을 뿐만 아니라 리소스의 주소 정보
                              또는 변환 파일 다운로드 기능을 통해 외부 시스템과
                              손쉽게 연동이 가능하여 활용도가 높은 시스템입니다.
                            </p>
                          </div>
                        </div>
                        <p className="ditap-used-img builder-used3"></p>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DitapBuilder;
